import React from 'react'
import { format } from 'date-fns'

import Spinner from '../../../components/Spinner'

import arrayUtils from '../../../util/array'
import { stringToDate } from '../../../util/date'

import {
    Container, Avatar
} from './styles'

import avatarDefault from '../../../assets/images/avatar.png'

export default function ({ pessoa }) {
    return (
        <Container
            className="animated fadeInUp delay-100ms"
            medico={pessoa?.associado.medico === null ? true : pessoa?.associado.medico}
        >
            {pessoa ? (
                <>
                    <Avatar
                        image={pessoa.usuario?.avatar?.link || avatarDefault}
                        className="animated zoomIn faster"
                    />

                    <h1 style={{ gridArea: 'nome' }} className="nome_completo">{pessoa.nome}</h1>

                    <h1 style={{ gridArea: 'nome' }} className="nome_reduzido">{pessoa.nome_reduzido}</h1>

                    <div style={{ gridArea: 'identificador' }} className="identificador flex gap-2">
                        <span>CPF: </span>
                        <b style={{ fontSize: 18 }}>{pessoa.documentos?.length > 0 && (pessoa.documentos.find(documento => documento.tipo_documento.id === 2)?.identificador || '')}</b>
                    </div>

                    <div style={{ gridArea: 'data' }}>
                        {pessoa.socio && pessoa.associado.sindicalizacao.find(sindicalizacao => sindicalizacao.status) ? (
                            <>
                                <span>Data de cadastro: </span>
                                <b>{format(stringToDate(arrayUtils.get.getLast(pessoa.associado.sindicalizacao.filter(sindicalizacao => sindicalizacao.status)).data), 'dd/MM/yyy')}</b>
                            </>
                        ) : null}
                    </div>
                </>
            ) : (
                <Spinner />
            )}
        </Container>
    )
}
